export function usePlaySession() {
  const playSessionStore = usePlaySessionStore()

  const resetSessionId = () => {
    const sessionId = playSessionStore.sessionId
    if (sessionId) {
      useApi().createSessionClose(sessionId)
      playSessionStore.resetSessionId()
    }
  }

  return {
    sessionId: playSessionStore.sessionId,
    setSessionId: playSessionStore.setSessionId,
    resetSessionId,
  }
}
